import React from 'react';
import styled from 'styled-components';

import type { IPopularMetaregionsOffer } from 'src/routes/Home/store/popularMetaregionsOffers/types';

import Card from '../../Card';
import CardHeading from '../../CardHeading';
import CardButton from '../../CardButton';
import CardImage from '../../CardImage';
import ContentContainer from '../../ContentContainer';

import { RELINKING_VARIANTS } from '../../../constants';

interface IPopularMetaregion extends IPopularMetaregionsOffer {
  isMobile: boolean;
}

export const PopularMetaregion = (props: IPopularMetaregion) => {
  const { imageUrl, title, link, regions, isMobile } = props;

  return (
    <Card $isMobile={isMobile} $variant={RELINKING_VARIANTS.METAREGIONS}>
      <CardImage src={imageUrl} fallback={imageUrl} loading="lazy" />
      <ContentContainer $variant={RELINKING_VARIANTS.METAREGIONS}>
        <CardHeading text={title} url={link} isMobile={isMobile} isBlack />
        <StyledButtonsContainer>
          {regions.map((region) => (
            <CardButton
              text={region.title}
              isMobile={isMobile}
              url={region.link}
              isBlue
              key={`${title}_region_${region.title}`}
            />
          ))}
        </StyledButtonsContainer>
      </ContentContainer>
    </Card>
  );
};

const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
